/*
  ws-pages.js: small enhancements for the home, Shop all and other non-product pages (A3).
  LAST UPDATED: 2026-10-09 PST - tracking fix: "Add to cart" on a product card sent the add-to-cart event two times; now one time
                 (note at "1. product card add buttons").
  Before that, 2026-10-09 PST - routine builder: free shipping counts the total after the first-subscription amount, as the checkout does
                 (it counted the amount before it). Note in mathHtml().
  2026-10-08 PST - the routine table has the class ws-math__table (Dawn restyles a table that has no class: equal columns, cell borders);
                 the table prints the short product name (JSON key "s") when the section sends one, else the title ("t").
  2026-10-07 PST: first version.
  Everything on these pages is already in the server-rendered HTML. This file only adds behavior:
    1. add-to-cart for product cards (forms with data-ws-add), then opens the cart drawer
    2. "What customers buy next" family toggle
    3. the routine builder (prices, per-day cost, the math, add routine to cart)
  Loaded with defer from the sections that need it. Safe to include more than once.
*/
(function () {
  if (window.WSPages) return;
  window.WSPages = { version: 1 };

  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- cart helpers ---------- */
  function afterAdd() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        qsa('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('ws:cart-updated', { detail: cart }));
      })
      .catch(function () {});
    var open = qs('[data-cart-open]');
    if (open) open.click();
  }
  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    });
  }

  /* ---------- 1. product card add buttons ----------
     TRACKING FIX (2026-10-09 PST, docs/audit/TRACKING_PARITY.md). WHAT WAS WRONG: one press of "Add to cart" on a product card sent the
     add-to-cart event to the ad and analytics tools TWO times (Meta AddToCart, GA4 add_to_cart, TikTok, Pinterest, Bing: measured on the
     preview theme, 2 events with 2 different event ids for 1 item in the cart). WHY: Shopify makes that event by itself in two ways. It
     watches a "submit" of a form that posts to /cart/add, and it watches a request to /cart/add.js. The old code let the form's "submit"
     event happen, cancelled it, and then sent the request: Shopify counted both.
     NOW: the press is taken at the "click" of the card button and cancelled there, so the form never sends a "submit" event. Shopify sees
     the request only: one event. The "submit" listener stays for any other code that submits the form; it does not run after a click.
     Without JavaScript the button still posts the form to /cart/add (one event, made by Shopify). */
  function addFromForm(form) {
    if (form.wsAdding) return;
    form.wsAdding = true;
    var id = form.querySelector('[name=id]').value;
    addItems([{ id: Number(id), quantity: 1 }])
      .then(function () { form.wsAdding = false; afterAdd(); })
      .catch(function () { form.wsAdding = false; form.submit(); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('button[type="submit"], input[type="submit"]') : null;
    if (!btn || btn.disabled || e.defaultPrevented) return;
    var form = btn.form;   // also set when the button is outside the form and names it with the form attribute (product cards)
    if (!form || !form.matches || !form.matches('form[data-ws-add]')) return;
    e.preventDefault();    // no "submit" event: see the note above
    addFromForm(form);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-ws-add]')) return;
    e.preventDefault();
    addFromForm(form);
  });

  /* ---------- 2. buy-next toggle ---------- */
  qsa('[data-fam]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.parentNode;
      qsa('[data-fam]', group).forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
      var capsules = qs('#bn-body'), powder = qs('#bn-body-powder');
      if (capsules) capsules.hidden = btn.dataset.fam !== 'capsules';
      if (powder) powder.hidden = btn.dataset.fam !== 'powder';
    });
  });

  /* ---------- 3. routine builder ---------- */
  var root = qs('[data-ws-builder]');
  if (root) initBuilder(root);

  function initBuilder(root) {
    var dataEl = qs('[data-ws-builder-data]', root), math = qs('#bld-math', root), limit = qs('#bld-limit', root);
    var list;
    try { list = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var by = {}; list.forEach(function (p) { by[p.h] = p; });
    var FREE_SHIP = Number(root.dataset.freeShip || 4000), FIRST = Number(root.dataset.firstCredit || 500);
    var cur = root.dataset.currency || 'USD';
    var fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: cur });
    var money = function (c) { return fmt.format(c / 100); };
    var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    var chosen = qsa('[name=pick]:checked', root).map(function (c) { return c.value; });
    var sizeIdx = {}, plan = 'sub';

    // the subscribe percentage is read from the real selling plan prices (first variant that has one)
    var SUB = 0.10;
    outer: for (var i = 0; i < list.length; i++) for (var j = 0; j < list[i].v.length; j++) { var v0 = list[i].v[j]; if (v0.sprice && v0.p > v0.sprice) { SUB = 1 - v0.sprice / v0.p; break outer; } }
    var subPct = Math.round(SUB * 100);
    var subPrice = function (v) { return v.sprice || Math.round(v.p * (1 - SUB)); };
    var perDay = function (v) { return v.n ? v.p / v.n : 0; };

    function mathHtml() {
      if (!chosen.length) return '<p class="ws-math__empty">Pick two or three products to see what your routine costs and where you save.</p>';
      var rows = chosen.map(function (h) { var p = by[h], i = sizeIdx[h] || 0, v = p.v[i] || p.v[0]; return { p: p, i: i, v: v, once: v.p, sub: subPrice(v), pd: perDay(v) }; });
      var once = rows.reduce(function (a, r) { return a + r.once; }, 0);
      var subTotal = rows.reduce(function (a, r) { return a + r.sub; }, 0);
      var merch = plan === 'sub' ? subTotal : once;
      var subDisc = once - merch, credit = plan === 'sub' ? Math.min(FIRST, merch) : 0, total = merch - credit;
      // 2026-10-09 PST: free shipping counts the amount AFTER the first-subscription amount, as the checkout does (tested: $43.12 with the $5 code
      // = $38.12, shipping is charged). Before, it counted "merch" (before the $5), so a routine between $40 and $45 was promised free shipping.
      var ship = total >= FREE_SHIP;
      var pdNow = rows.reduce(function (a, r) { return a + r.pd; }, 0);
      var pdBig = rows.reduce(function (a, r) {
        var vs = r.p.v.filter(function (x) { return x.n; });
        var big = vs.length ? vs.reduce(function (m, x) { return x.n > m.n ? x : m; }) : null;
        return a + (big ? big.p / big.n : r.pd);
      }, 0);
      var bigNote = pdNow && pdBig < pdNow - 0.5 ? '<p class="ws-note"><b>Bigger sizes:</b> the same routine at each product\'s biggest size costs ' + money(pdBig) + ' a day instead of ' + money(pdNow) + ' a day (' + Math.round((1 - pdBig / pdNow) * 100) + '% less per serving).</p>' : '';
      var body = rows.map(function (r) {
        var sel = '';
        if (r.p.v.length > 1) {
          sel = '<br><label class="ws-visually-hidden" for="sz-' + esc(r.p.h) + '">Size for ' + esc(r.p.s || r.p.t) + '</label><select class="ws-select" id="sz-' + esc(r.p.h) + '" data-size="' + esc(r.p.h) + '">' +
            r.p.v.map(function (v, i) { return '<option value="' + i + '"' + (i === r.i ? ' selected' : '') + '>' + (v.n ? v.n + '-day' : esc(v.t)) + ', ' + money(v.p) + '</option>'; }).join('') + '</select>';
        }
        return '<tr><td><b>' + esc(r.p.s || r.p.t) + '</b>' + sel + (r.pd ? '<br><small>' + money(r.pd) + ' a day</small>' : '') + '</td><td>' + (plan === 'sub' ? '<s>' + money(r.once) + '</s><br>' + money(r.sub) : money(r.once)) + '</td></tr>';
      }).join('');
      return '<h3>Your routine</h3>' +
        '<table class="ws-math__table"><caption class="ws-visually-hidden">Routine cost</caption><thead><tr><th scope="col">Product and size</th><th scope="col">' + (plan === 'sub' ? 'Subscribed' : 'Price') + '</th></tr></thead><tbody>' + body + '</tbody><tfoot>' +
        '<tr><td>Subtotal</td><td>' + money(once) + '</td></tr>' +
        (plan === 'sub' ? '<tr><td>Subscribe and save ' + subPct + '% (' + subPct + '% of ' + money(once) + ')</td><td>&minus;' + money(subDisc) + '</td></tr><tr><td>First subscription credit</td><td>&minus;' + money(credit) + '</td></tr>' : '') +
        '<tr><td>Shipping</td><td>' + (ship ? 'Free' : 'At checkout') + '</td></tr>' +
        '<tr><th scope="row">Estimated total</th><td>' + money(total) + '</td></tr></tfoot></table>' +
        '<p class="ws-note">' + (ship ? 'Your order is over ' + money(FREE_SHIP).replace(/\.00$/, '') + ', so shipping is free.' : 'Add ' + money(FREE_SHIP - total) + ' more to get free shipping.') + ' ' + (plan === 'sub' ? '' : 'Choose "Subscribe and save" to take ' + subPct + '% off and ' + money(FIRST).replace(/\.00$/, '') + ' off your first subscription.') + '</p>' +
        bigNote +
        '<button class="ws-btn ws-btn--arrow" type="button" id="bld-add">Add routine to cart</button>' +
        '<p class="ws-note">There is no extra bundle discount. You save through the four things above: subscribing, your first-subscription credit, bigger sizes, and free shipping over ' + money(FREE_SHIP).replace(/\.00$/, '') + '.</p>';
    }
    function render() { math.innerHTML = mathHtml(); }
    render();

    qsa('[name=pick]', root).forEach(function (c) {
      c.addEventListener('change', function () {
        if (c.checked) {
          if (chosen.length >= 3) { c.checked = false; limit.textContent = 'You can pick up to three. Uncheck one to swap.'; return; }
          chosen.push(c.value);
        } else chosen = chosen.filter(function (h) { return h !== c.value; });
        limit.textContent = '';
        render();
      });
    });
    qsa('[data-plan]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        plan = b.dataset.plan;
        qsa('[data-plan]', root).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        render();
      });
    });
    math.addEventListener('change', function (e) {
      if (e.target.dataset && e.target.dataset.size) { sizeIdx[e.target.dataset.size] = +e.target.value; render(); }
    });
    math.addEventListener('click', function (e) {
      if (e.target.id !== 'bld-add') return;
      var btn = e.target; btn.disabled = true;
      var items = chosen.map(function (h) {
        var p = by[h], v = p.v[sizeIdx[h] || 0] || p.v[0], it = { id: v.id, quantity: 1 };
        if (plan === 'sub' && v.sp) it.selling_plan = v.sp;
        return it;
      });
      addItems(items).then(function () { btn.disabled = false; afterAdd(); }).catch(function () { btn.disabled = false; limit.textContent = 'Sorry, that did not work. Please try again.'; });
    });
  }
})();
